module.exports = __webpack_public_path__ + "media/assets/images/logo_autre-e91b03e876f831a72506b7450414ee69.svg";